import { useEffect, useState } from 'react';

/**
 * Debounced mirror of a value. Used so dragging a radius slider issues one
 * buffer request when the drag settles instead of one per pixel — the station
 * filtering itself stays instant, since it runs on precomputed distances.
 */
const useDebouncedValue = (value, delayMs) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
};

export default useDebouncedValue;
